/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Time_Not_AvailableInputs */

const en_admin_external_booking_edit_time_not_available = /** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This time slot is not available for the selected resource.`)
};

const de_admin_external_booking_edit_time_not_available = /** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Zeitraum ist für die ausgewählte Ressource nicht verfügbar.`)
};

const es_admin_external_booking_edit_time_not_available = /** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta franja horaria no está disponible para el recurso seleccionado.`)
};

const fr_admin_external_booking_edit_time_not_available = /** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce créneau n'est pas disponible pour la ressource sélectionnée.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */
const it_admin_external_booking_edit_time_not_available = en_admin_external_booking_edit_time_not_available;

/** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_time_not_available = en_admin_external_booking_edit_time_not_available;

/** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */
const pl_admin_external_booking_edit_time_not_available = en_admin_external_booking_edit_time_not_available;

/** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */
const hu_admin_external_booking_edit_time_not_available = en_admin_external_booking_edit_time_not_available;

/** @type {(inputs: Admin_External_Booking_Edit_Time_Not_AvailableInputs) => LocalizedString} */
const ro_admin_external_booking_edit_time_not_available = en_admin_external_booking_edit_time_not_available;

/**
* | output |
* | --- |
* | "This time slot is not available for the selected resource." |
*
* @param {Admin_External_Booking_Edit_Time_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_time_not_available = /** @type {((inputs?: Admin_External_Booking_Edit_Time_Not_AvailableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Time_Not_AvailableInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "de") return de_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "es") return es_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "it") return it_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_time_not_available(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_time_not_available(inputs)
	return ro_admin_external_booking_edit_time_not_available(inputs)
});
export { admin_external_booking_edit_time_not_available as "admin.external_booking_edit.time_not_available" }